import { CircularProgress, Stack } from "@mui/material";

export type LoadingGuardProps = {
  isLoading?: boolean | null;
  children: React.ReactNode;
  loadingComponent?: React.ReactNode;
  size?: number;
};

export function LoadingGuard({
  isLoading,
  children,
  loadingComponent,
  size,
}: LoadingGuardProps) {
  if (isLoading) {
    return (
      <Stack
        alignItems={"center"}
        justifyContent={"center"}
        flex={1}
        width={"100%"}
        height={"100%"}
      >
        {loadingComponent || <CircularProgress size={size || 48} />}
      </Stack>
    );
  }
  return <>{children}</>;
}
